





























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
class AssessmentResultPercentItem extends Vue {
  @Prop({
    type: Number,
    required: true,
  }) value!: number;

  @Prop({
    type: String,
    required: false,
    default: 'Aderência Total',
  }) label!: string;

  @Prop({
    type: String,
    required: false,
    default: '#1976D2',
  }) color!: string;

  @Prop({
    type: String,
    required: false,
    default: () => null,
  }) tooltip!: string;
}

export default AssessmentResultPercentItem;
